import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// import sections
import Hero from '../components/sections/Hero';
import ProductGoddessMecha from '../components/sections/ProductGoddessMecha';
import ProductIbashoTown from '../components/sections/ProductIbashoTown';
import About from '../components/sections/About';

const Home = () => {

  const { hash } = useLocation();

  // Jump to a section when the page is opened with /#section-id (e.g. from the header on other routes).
  useEffect(() => {
    if (!hash) return;
    const target = document.getElementById(hash.slice(1));
    if (target) {
      window.requestAnimationFrame(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    }
  }, [hash]);

  return (
    <>
      <Hero />
      <ProductGoddessMecha />
      <ProductIbashoTown />
      <About />
    </>
  );
}

export default Home;
